var _path, _g, _g2, _g3, _g4, _path2, _path3, _path4, _g5, _path5, _path6, _g6, _g7, _g8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroMobTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 728,
    viewBox: "0 0 430 728",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "hero-mob-img 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 482209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck-mob"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 482231"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_1468",
    opacity: 0.3,
    d: "M227.694 687L176.191 657.54L340.374 564.006L391.877 593.454L227.694 687Z",
    fill: "#EFECEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1469",
    d: "M361.954 570.575V572.639L342.922 561.747V559.694L332.038 553.467L330.406 554.505L332.038 562.591L371.218 586.964L372.838 585.926V576.802L361.954 570.575Z",
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1470",
    d: "M360.333 571.623V573.676L341.291 562.784V560.731L330.406 554.504V563.628L371.218 586.963V577.839L360.333 571.623Z",
    fill: "#001E33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_146"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1471",
    d: "M290.356 618.329L290.472 618.395H290.48C292.621 619.678 293.938 621.985 293.938 624.476L293.96 632.603L269.363 646.661L266.475 638.766L266.452 638.702L266.412 638.647L259.295 628.685L283.918 614.65L290.356 618.329Z",
    fill: "#222222",
    stroke: "url(#paint0_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1472",
    d: "M259.055 641.066V629.388L263.669 632.027V632.028C266.708 633.763 268.586 636.996 268.586 640.501V646.516L259.055 641.066Z",
    fill: "#222222",
    stroke: "url(#paint1_linear_3256_4486)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1473",
    d: "M361.694 583.701C361.694 583.701 365.801 585.401 365.961 591.582L363.166 590.111L359.058 586.826L356.149 585.081L354.859 583.382C356.331 580.919 361.694 583.701 361.694 583.701Z",
    fill: "#3542B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1474",
    d: "M360.461 584.887L353.193 580.69C352.828 580.405 352.428 580.177 352.018 580.006H352.006C350.375 579.333 348.378 579.516 346.222 580.713C340.711 583.781 336.238 592.312 336.238 599.771C336.238 604.003 337.676 606.979 339.924 608.211H339.912L348.492 613.127L348.344 611.313L346.724 607.675C346.724 607.675 346.667 607.618 346.575 607.527C351.938 604.311 356.216 595.973 356.216 588.663C356.216 587.864 356.159 587.1 356.068 586.393H357.255L360.484 584.876L360.461 584.887Z",
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1475",
    d: "M364.853 593.634C364.853 601.093 360.381 609.636 354.87 612.692C349.359 615.76 344.887 612.191 344.887 604.732C344.887 597.273 349.359 588.73 354.87 585.673C360.381 582.605 364.853 586.175 364.853 593.634Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1476",
    d: "M361.759 595.357C361.759 600.513 358.667 606.409 354.868 608.519C351.057 610.64 347.977 608.177 347.977 603.022C347.977 597.867 351.069 591.97 354.868 589.86C358.679 587.739 361.759 590.202 361.759 595.357Z",
    fill: "url(#paint2_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1477",
    d: "M360.47 596.076C360.47 600.262 357.96 605.052 354.868 606.774C351.776 608.497 349.266 606.489 349.266 602.303C349.266 598.118 351.776 593.328 354.868 591.605C357.96 589.883 360.47 591.89 360.47 596.076Z",
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1478",
    d: "M359.65 596.531C359.65 600.112 357.505 604.195 354.858 605.667C352.211 607.138 350.066 605.427 350.066 601.846C350.066 598.265 352.211 594.182 354.858 592.71C357.505 591.239 359.65 592.95 359.65 596.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1479",
    d: "M359.069 596.851C359.069 599.987 357.187 603.58 354.871 604.869C352.554 606.158 350.672 604.664 350.672 601.516C350.672 598.368 352.554 594.787 354.871 593.498C357.187 592.209 359.069 593.703 359.069 596.851Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1480",
    d: "M356.605 598.22C356.605 599.52 355.829 601.003 354.871 601.539C353.913 602.075 353.137 601.448 353.137 600.147C353.137 598.847 353.913 597.364 354.871 596.828C355.829 596.292 356.605 596.92 356.605 598.22Z",
    fill: "#D7F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1481",
    d: "M357.028 598.528C357.028 599.76 356.286 601.174 355.373 601.676C354.46 602.178 353.719 601.596 353.719 600.364C353.719 599.132 354.46 597.718 355.373 597.216C356.286 596.714 357.028 597.296 357.028 598.528Z",
    fill: "url(#paint3_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1482",
    d: "M358.336 594.328C358.404 594.294 358.461 594.248 358.53 594.191C358.267 593.724 357.925 593.37 357.514 593.153C357.48 593.302 357.457 593.461 357.457 593.61C357.457 594.271 357.856 594.59 358.347 594.317L358.336 594.328Z",
    fill: "url(#paint4_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1483",
    d: "M358.003 600.442C357.513 600.715 357.113 601.479 357.113 602.141C357.113 602.289 357.136 602.426 357.17 602.529C357.627 601.867 358.026 601.126 358.334 600.339C358.231 600.339 358.117 600.373 357.992 600.43L358.003 600.442Z",
    fill: "url(#paint5_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1484",
    d: "M354.879 593.37C354.594 593.53 354.309 593.724 354.035 593.952C354.149 594.374 354.48 594.545 354.879 594.328C355.279 594.112 355.61 593.564 355.724 593.017C355.45 593.096 355.165 593.21 354.879 593.37Z",
    fill: "url(#paint6_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1485",
    d: "M358.336 596.724C358.336 597.305 358.644 597.625 359.043 597.511C359.066 597.248 359.089 596.974 359.089 596.712C359.089 596.176 359.032 595.697 358.929 595.264C358.587 595.617 358.336 596.199 358.336 596.724Z",
    fill: "url(#paint7_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1486",
    d: "M352.515 605.061C352.595 604.844 352.641 604.605 352.641 604.388C352.641 603.727 352.241 603.407 351.751 603.681C351.602 603.761 351.454 603.898 351.34 604.057C351.648 604.548 352.047 604.89 352.526 605.073L352.515 605.061Z",
    fill: "url(#paint8_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1487",
    d: "M354.879 603.669C354.457 603.909 354.103 604.502 354.012 605.095C354.297 605.015 354.582 604.901 354.879 604.73C355.176 604.559 355.472 604.365 355.746 604.126C355.655 603.635 355.301 603.43 354.879 603.669Z",
    fill: "url(#paint9_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1488",
    d: "M351.421 600.818C351.421 600.27 351.159 599.974 350.794 600.019C350.725 600.475 350.68 600.932 350.68 601.376C350.68 601.719 350.703 602.049 350.748 602.357C351.136 602.015 351.421 601.376 351.421 600.818Z",
    fill: "url(#paint10_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1489",
    d: "M351.752 597.773C352.242 597.499 352.642 596.735 352.642 596.073C352.642 595.891 352.608 595.743 352.562 595.617C352.094 596.302 351.695 597.066 351.387 597.875C351.501 597.875 351.626 597.853 351.752 597.784V597.773Z",
    fill: "url(#paint11_linear_3256_4486)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1490",
    d: "M334.109 599.965L343.35 604.14C343.35 604.14 343.59 588.161 355.387 583.701C355.387 583.701 358.696 582.447 361.697 583.701L356.311 581.295L335.329 593.293C335.329 593.293 333.869 595.757 334.109 599.965Z",
    fill: "#222222"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1491",
    d: "M336.713 598.051C336.713 598.051 340.821 599.75 340.98 605.932L338.185 604.461L334.078 601.176L331.168 599.431L329.879 597.732C331.351 595.268 336.713 598.051 336.713 598.051Z",
    fill: "#3542B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1492",
    d: "M335.48 599.237L328.212 595.04C327.847 594.755 327.448 594.527 327.037 594.356H327.026C325.394 593.683 323.398 593.865 321.241 595.063C315.73 598.131 311.258 606.662 311.258 614.121C311.258 618.352 312.695 621.329 314.943 622.561H314.932L323.512 627.476L323.363 625.663L321.743 622.025C321.743 622.025 321.686 621.968 321.595 621.876C326.957 618.66 331.236 610.323 331.236 603.012C331.236 602.214 331.179 601.45 331.088 600.743H332.274L335.503 599.226L335.48 599.237Z",
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1493",
    d: "M339.873 607.996C339.873 615.455 335.4 623.997 329.89 627.054C324.379 630.122 319.906 626.552 319.906 619.093C319.906 611.634 324.379 603.091 329.89 600.035C335.4 596.967 339.873 600.537 339.873 607.996Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1494",
    d: "M336.779 609.707C336.779 614.862 333.687 620.759 329.887 622.869C326.077 624.99 322.996 622.527 322.996 617.371C322.996 612.216 326.088 606.32 329.887 604.21C333.698 602.088 336.779 604.552 336.779 609.707Z",
    fill: "url(#paint12_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1495",
    d: "M335.489 610.426C335.489 614.612 332.979 619.402 329.887 621.124C326.795 622.846 324.285 620.839 324.285 616.653C324.285 612.467 326.795 607.677 329.887 605.955C332.979 604.233 335.489 606.24 335.489 610.426Z",
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1496",
    d: "M334.67 610.881C334.67 614.462 332.525 618.545 329.878 620.016C327.231 621.488 325.086 619.777 325.086 616.196C325.086 612.614 327.231 608.531 329.878 607.06C332.525 605.589 334.67 607.299 334.67 610.881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1497",
    d: "M333.316 614.942C334.662 611.633 334.219 608.328 332.328 607.559C330.436 606.791 327.813 608.85 326.467 612.159C325.122 615.467 325.565 618.772 327.456 619.541C329.347 620.309 331.971 618.25 333.316 614.942Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1498",
    d: "M331.625 612.569C331.625 613.87 330.849 615.352 329.89 615.888C328.932 616.424 328.156 615.797 328.156 614.497C328.156 613.197 328.932 611.714 329.89 611.178C330.849 610.642 331.625 611.269 331.625 612.569Z",
    fill: "#D7F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1499",
    d: "M332.059 612.877C332.059 614.109 331.317 615.523 330.404 616.025C329.492 616.527 328.75 615.945 328.75 614.714C328.75 613.482 329.492 612.068 330.404 611.566C331.317 611.064 332.059 611.646 332.059 612.877Z",
    fill: "url(#paint13_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1500",
    d: "M333.333 608.817C333.401 608.783 333.458 608.737 333.527 608.68C333.264 608.213 332.922 607.859 332.511 607.643C332.477 607.791 332.454 607.951 332.454 608.099C332.454 608.76 332.853 609.08 333.344 608.806L333.333 608.817Z",
    fill: "url(#paint14_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1501",
    d: "M333.012 614.931C332.521 615.204 332.122 615.969 332.122 616.63C332.122 616.778 332.145 616.915 332.179 617.018C332.636 616.356 333.035 615.615 333.343 614.828C333.24 614.828 333.126 614.862 333.001 614.919L333.012 614.931Z",
    fill: "url(#paint15_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1502",
    d: "M329.887 607.859C329.602 608.019 329.317 608.213 329.043 608.441C329.157 608.863 329.488 609.034 329.887 608.817C330.287 608.601 330.617 608.053 330.732 607.506C330.458 607.586 330.172 607.7 329.887 607.859Z",
    fill: "url(#paint16_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1503",
    d: "M333.333 611.213C333.333 611.794 333.641 612.114 334.04 612C334.063 611.737 334.086 611.464 334.086 611.201C334.086 610.665 334.029 610.186 333.926 609.753C333.584 610.106 333.333 610.688 333.333 611.213Z",
    fill: "url(#paint17_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1504",
    d: "M327.515 619.55C327.595 619.334 327.641 619.094 327.641 618.877C327.641 618.216 327.241 617.897 326.751 618.17C326.602 618.25 326.454 618.387 326.34 618.547C326.648 619.037 327.047 619.379 327.526 619.562L327.515 619.55Z",
    fill: "url(#paint18_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1505",
    d: "M329.888 618.159C329.466 618.398 329.112 618.991 329.021 619.584C329.306 619.505 329.591 619.39 329.888 619.219C330.184 619.048 330.481 618.854 330.755 618.615C330.664 618.124 330.31 617.919 329.888 618.159Z",
    fill: "url(#paint19_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1506",
    d: "M326.429 615.308C326.429 614.76 326.167 614.464 325.802 614.509C325.733 614.966 325.688 615.422 325.688 615.867C325.688 616.209 325.711 616.54 325.757 616.848C326.145 616.505 326.429 615.867 326.429 615.308Z",
    fill: "url(#paint20_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1507",
    d: "M326.748 612.262C327.239 611.988 327.638 611.224 327.638 610.563C327.638 610.38 327.604 610.232 327.558 610.106C327.09 610.791 326.691 611.555 326.383 612.365C326.497 612.365 326.622 612.342 326.748 612.273V612.262Z",
    fill: "url(#paint21_linear_3256_4486)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1508",
    d: "M309.132 614.315L318.374 618.489C318.374 618.489 318.613 602.51 330.411 598.051C330.411 598.051 333.72 596.796 336.72 598.051L331.335 595.645L310.353 607.643C310.353 607.643 308.892 610.106 309.132 614.315Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_154"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_1509",
    d: "M388.885 503.482V559.288L270.875 626.742V570.936L388.885 503.482Z",
    fill: "#222222",
    stroke: "url(#paint22_linear_3256_4486)",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_1510",
    d: "M389.702 502.086V559.763L270.062 628.137V570.461L389.702 502.075M391.893 498.3L267.871 569.183V631.901L391.893 561.017V498.311V498.3Z",
    fill: "#222222"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_1511",
    d: "M267.88 565.683L222.414 539.683L340.371 472.454L385.825 498.444L267.88 565.683Z",
    fill: "#222222",
    stroke: "url(#paint23_linear_3256_4486)",
    strokeWidth: 6
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1512",
    d: "M340.374 471.521L387.472 498.448L267.878 566.617L220.779 539.69L340.374 471.521ZM340.374 469L216.375 539.678L267.878 569.127L391.876 498.448L340.374 469Z",
    fill: "#222222"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_1513",
    d: "M264.877 570.878V626.729L219.363 600.7V544.849L264.877 570.878Z",
    fill: "#222222",
    stroke: "url(#paint24_linear_3256_4486)",
    strokeWidth: 6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_1514",
    d: "M218.554 543.453L265.687 570.415V628.137L218.554 601.175V543.453ZM216.363 539.678V602.441L267.866 631.901V569.137L216.363 539.678Z",
    fill: "#222222"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1515",
    d: "M186.197 611.339L184.805 612.228V592.109L186.197 591.22V611.339Z",
    fill: "url(#paint25_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1516",
    d: "M184.803 592.098L176.977 587.718L178.369 586.874L186.184 591.254L184.803 592.098Z",
    fill: "url(#paint26_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1517",
    d: "M184.803 612.229L176.977 607.849V587.719L184.803 592.098V612.229Z",
    fill: "#001E1A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1518",
    d: "M228.65 608.72L183.608 582.961L218.645 562.871L263.676 588.63L228.65 608.72Z",
    fill: "url(#paint27_linear_3256_4486)",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1519",
    d: "M262.527 651.94L258.557 650.047L251.186 644.995L245.812 641.185V638.311L257.656 631.913L263.577 630.727V633.589",
    fill: "#000508"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1520",
    d: "M256.789 644.208L249.521 640.011C249.156 639.725 248.756 639.497 248.346 639.326H248.334C246.703 638.653 244.706 638.836 242.55 640.033C237.039 643.101 232.566 651.633 232.566 659.092C232.566 663.323 234.004 666.3 236.252 667.531H236.24L244.82 672.447L244.672 670.634L243.052 666.995C243.052 666.995 242.995 666.938 242.903 666.847C248.266 663.631 252.544 655.294 252.544 647.983C252.544 647.184 252.487 646.42 252.396 645.713H253.583L256.812 644.196L256.789 644.208Z",
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1521",
    d: "M256.794 644.764C258.804 645.58 260.132 647.785 260.547 650.874C260.959 653.947 260.442 657.787 258.871 661.651C257.299 665.516 254.989 668.627 252.549 670.541C250.097 672.466 247.606 673.118 245.597 672.302C243.587 671.485 242.258 669.281 241.844 666.192C241.432 663.119 241.948 659.278 243.52 655.414C245.091 651.55 247.401 648.438 249.841 646.524C252.294 644.6 254.784 643.947 256.794 644.764Z",
    fill: "#222222",
    stroke: "url(#paint28_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1522",
    d: "M258.091 654.678C258.091 659.833 254.999 665.729 251.2 667.839C247.389 669.961 244.309 667.497 244.309 662.342C244.309 657.187 247.401 651.29 251.2 649.18C255.011 647.059 258.091 649.523 258.091 654.678Z",
    fill: "url(#paint29_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1523",
    d: "M256.798 655.397C256.798 659.582 254.288 664.372 251.196 666.095C248.104 667.817 245.594 665.81 245.594 661.624C245.594 657.438 248.104 652.648 251.196 650.926C254.288 649.203 256.798 651.211 256.798 655.397Z",
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1524",
    d: "M255.979 655.852C255.979 659.434 253.834 663.517 251.187 664.988C248.539 666.459 246.395 664.748 246.395 661.167C246.395 657.586 248.539 653.503 251.187 652.032C253.834 650.56 255.979 652.271 255.979 655.852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1525",
    d: "M255.397 656.183C255.397 659.32 253.515 662.912 251.199 664.201C248.883 665.49 247 663.996 247 660.848C247 657.7 248.883 654.119 251.199 652.83C253.515 651.541 255.397 653.035 255.397 656.183Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1526",
    d: "M252.933 657.552C252.933 658.852 252.157 660.335 251.199 660.871C250.241 661.407 249.465 660.78 249.465 659.479C249.465 658.179 250.241 656.697 251.199 656.16C252.157 655.624 252.933 656.252 252.933 657.552Z",
    fill: "#D7F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1527",
    d: "M253.356 657.86C253.356 659.092 252.614 660.506 251.701 661.008C250.789 661.51 250.047 660.928 250.047 659.696C250.047 658.464 250.789 657.05 251.701 656.548C252.614 656.046 253.356 656.628 253.356 657.86Z",
    fill: "url(#paint30_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1528",
    d: "M254.644 653.788C254.713 653.754 254.77 653.708 254.838 653.651C254.576 653.184 254.233 652.83 253.823 652.613C253.788 652.762 253.766 652.921 253.766 653.069C253.766 653.731 254.165 654.05 254.656 653.777L254.644 653.788Z",
    fill: "url(#paint31_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1529",
    d: "M254.312 659.901C253.821 660.175 253.422 660.939 253.422 661.601C253.422 661.749 253.445 661.886 253.479 661.989C253.935 661.327 254.335 660.586 254.643 659.799C254.54 659.799 254.426 659.833 254.3 659.89L254.312 659.901Z",
    fill: "url(#paint32_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1530",
    d: "M251.188 652.83C250.903 652.99 250.618 653.184 250.344 653.412C250.458 653.834 250.789 654.005 251.188 653.788C251.587 653.571 251.918 653.024 252.032 652.477C251.759 652.556 251.473 652.67 251.188 652.83Z",
    fill: "url(#paint33_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1531",
    d: "M254.645 656.184C254.645 656.765 254.953 657.085 255.352 656.97C255.375 656.708 255.398 656.434 255.398 656.172C255.398 655.636 255.341 655.157 255.238 654.724C254.896 655.077 254.645 655.659 254.645 656.184Z",
    fill: "url(#paint34_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1532",
    d: "M248.824 664.521C248.903 664.304 248.949 664.065 248.949 663.848C248.949 663.187 248.55 662.867 248.059 663.141C247.911 663.221 247.763 663.358 247.648 663.517C247.956 664.008 248.356 664.35 248.835 664.532L248.824 664.521Z",
    fill: "url(#paint35_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1533",
    d: "M251.187 663.141C250.765 663.381 250.412 663.974 250.32 664.567C250.606 664.487 250.891 664.373 251.187 664.202C251.484 664.031 251.781 663.837 252.055 663.597C251.963 663.107 251.61 662.902 251.187 663.141Z",
    fill: "url(#paint36_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1534",
    d: "M247.73 660.288C247.73 659.741 247.467 659.444 247.102 659.49C247.034 659.946 246.988 660.402 246.988 660.847C246.988 661.189 247.011 661.52 247.057 661.828C247.445 661.486 247.73 660.847 247.73 660.288Z",
    fill: "url(#paint37_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1535",
    d: "M248.049 657.244C248.539 656.971 248.939 656.207 248.939 655.545C248.939 655.363 248.904 655.214 248.859 655.089C248.391 655.773 247.992 656.537 247.684 657.347C247.798 657.347 247.923 657.324 248.049 657.256V657.244Z",
    fill: "url(#paint38_linear_3256_4486)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1536",
    d: "M248.05 639.987L257.314 635.243L262.528 641.379V651.94L264.696 650.697V588.516L228.642 609.364L218.031 634.73L220.439 676.131L238.489 665.775C239.983 649.431 248.05 640.01 248.05 640.01V639.987Z",
    fill: "#D0E1EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1537",
    d: "M246.292 632.313L253.115 628.811C256.413 627.385 258.558 624.146 258.558 620.554V597.96L231.996 613.311L227.056 633.59L225.949 656.537L237.256 650.048C240.143 640.171 246.292 632.313 246.292 632.313Z",
    fill: "#B1C8DA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1538",
    d: "M234.997 613.504L230.536 631.821L230.285 636.748L251.575 624.522V604.004L234.997 613.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1539",
    d: "M250.846 624.168V605.189L235.523 613.971L231.245 631.536L231.051 635.539L250.846 624.168Z",
    fill: "#161C21"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1540",
    d: "M171 637.877L175.552 635.493V637.341L175.37 638.356L174.172 639.029",
    fill: "url(#paint39_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1541",
    d: "M220.451 669.983L174.402 643.649C174.402 643.649 174.665 621.306 175.669 613.869C176.718 606.148 182.606 582.973 182.606 582.973L228.655 609.307C228.655 609.307 223.235 629.016 222.345 635.585C221.181 644.185 220.451 669.983 220.451 669.983Z",
    fill: "#B1C8DA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1542",
    d: "M221.678 642.736C221.883 639.873 222.1 637.364 222.34 635.585C223.23 629.016 228.649 609.307 228.649 609.307L182.601 582.973C182.601 582.973 176.713 606.148 175.664 613.869C175.549 614.679 175.458 615.66 175.355 616.778L221.667 642.748L221.678 642.736Z",
    fill: "#161C21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1543",
    d: "M175.551 616.869L221.794 641.185L223.642 624.35L191.045 607.539L175.551 616.504V616.869Z",
    fill: "#0F101B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1544",
    d: "M182.601 582.962C182.601 582.962 176.713 606.137 175.664 613.859C175.549 614.668 175.458 615.649 175.355 616.767L221.667 642.737C221.872 639.874 222.089 637.365 222.328 635.586C223.218 629.016 228.638 609.308 228.638 609.308L182.589 582.973L182.601 582.962ZM220.788 635.369C220.628 636.578 220.457 638.186 220.298 640.171L177.01 615.9C177.078 615.205 177.147 614.589 177.215 614.075C178.06 607.848 182.167 591.128 183.616 585.357L226.824 610.072C225.637 614.452 221.564 629.644 220.788 635.392V635.369Z",
    fill: "url(#paint40_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1545",
    d: "M218.406 675.994L220.22 676.975L233.889 667.041L235.714 657.005L233.889 656.035L218.406 664.988V675.994Z",
    fill: "url(#paint41_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1546",
    d: "M222.046 675.914L220.232 677.043L172.826 647.914L171 637.878L172.826 636.908L222.058 665.056L222.046 675.914Z",
    fill: "#477FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1547",
    d: "M177.23 639.429L172.826 636.908L171 637.889L172.826 647.926L176.294 650.058C175.781 646.568 176.294 642.862 177.23 639.44V639.429Z",
    fill: "url(#paint42_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1548",
    d: "M211.87 659.24L182.16 642.246C181.201 646.352 180.927 651.062 184.054 654.199C186.678 656.833 190.477 658.099 193.991 659.035C198.076 660.118 202.275 662.091 206.553 662.205C209.052 662.274 210.843 661.042 211.87 659.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1549",
    d: "M216.65 661.966C215.144 664.612 212.725 666.676 209.599 667.395C208.047 667.748 206.473 667.782 204.898 667.623L220.233 677.044L222.047 675.914V665.057L216.65 661.966Z",
    fill: "#477FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1550",
    d: "M208.928 657.552L207.103 658.521L208.928 660.027L185.961 646.899V644.413L172.84 636.908V647.914L220.235 677.043L222.06 675.914L222.791 664.304L220.166 663.973L208.928 657.552Z",
    fill: "url(#paint43_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1551",
    d: "M207.1 658.52V661.007L184.132 647.868V645.393L171 637.877V648.883L220.232 677.043V666.036L207.1 658.52Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1552",
    d: "M185.954 644.413L184.129 645.394V647.869L185.954 646.899V644.413Z",
    fill: "#93D7FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1553",
    d: "M213.17 580.851L200.004 588.47V585.231L213.17 580.064V580.851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1554",
    d: "M200.004 585.219L195.383 582.551L208.549 577.43L213.17 580.099L200.004 585.219Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1555",
    d: "M200.004 588.47L195.383 585.801V582.551L200.004 585.22V588.47Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1556",
    d: "M199.457 587.569L195.84 585.505V583.44L199.457 585.516V587.569Z",
    fill: "url(#paint44_linear_3256_4486)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1557",
    d: "M225.803 587.695L212.637 595.314V592.075L225.803 586.908V587.695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1558",
    d: "M212.637 592.063L208.016 589.394L221.182 584.273L225.803 586.942L212.637 592.063Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1559",
    d: "M212.637 595.314L208.016 592.645V589.395L212.637 592.063V595.314Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1560",
    d: "M212.089 594.413L208.473 592.349V590.284L212.089 592.36V594.413Z",
    fill: "url(#paint45_linear_3256_4486)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1561",
    d: "M238.428 594.537L225.262 602.156V598.917L238.428 593.75V594.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1562",
    d: "M225.261 598.905L220.641 596.236L233.807 591.115L238.428 593.784L225.261 598.905Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1563",
    d: "M225.261 602.156L220.641 599.487V596.236L225.261 598.905V602.156Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1564",
    d: "M224.714 601.255L221.098 599.19V597.126L224.714 599.202V601.255Z",
    fill: "url(#paint46_linear_3256_4486)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1565",
    d: "M222.915 609.147L217.941 606.296L197.586 626.654L202.595 629.46L222.915 609.147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1566",
    d: "M197.836 594.8L179.649 612.98C179.592 613.311 179.547 613.63 179.512 613.915C179.421 614.599 179.33 615.443 179.25 616.39L192.588 623.872L212.988 603.479L197.825 594.811L197.836 594.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1567",
    d: "M222.424 617.77L207.797 632.391L209.942 633.6L221.283 622.263C221.659 620.735 222.047 619.207 222.412 617.781L222.424 617.77Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1568",
    d: "M215.69 659.478L179.465 638.755V625.012L215.69 645.735V659.478Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1569",
    d: "M181.281 637.878L213.878 656.526V654.507L181.281 635.86V637.878ZM181.281 627.979V629.997L213.878 648.645V646.626L181.281 627.979ZM181.281 633.943L213.878 652.591V650.572L181.281 631.925V633.943Z",
    fill: "url(#paint47_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1570",
    d: "M220.223 676.975L235.717 668.011V657.005L220.223 665.969V676.975Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1571",
    d: "M242.329 639.599L240.938 640.5V620.381L242.329 619.48V639.599Z",
    fill: "url(#paint48_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1572",
    d: "M240.941 620.359L233.125 615.979L234.517 615.146L242.332 619.515L240.941 620.359Z",
    fill: "url(#paint49_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1573",
    d: "M240.941 640.501L233.125 636.121V615.979L240.941 620.359V640.501Z",
    fill: "#001208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1574",
    d: "M237.482 640.353C237.413 640.353 237.333 640.33 237.265 640.296L225.969 633.966C225.764 633.852 225.684 633.578 225.798 633.373C225.912 633.167 226.186 633.088 226.392 633.202L237.037 639.167V637.878C237.037 637.638 237.231 637.444 237.47 637.444C237.71 637.444 237.904 637.638 237.904 637.878V639.919C237.904 640.079 237.824 640.216 237.687 640.296C237.619 640.33 237.539 640.353 237.47 640.353H237.482Z",
    fill: "#001208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1575",
    d: "M237.479 618.192C237.239 618.192 237.045 617.998 237.045 617.758V615.705L231.044 612.341C230.838 612.227 230.758 611.953 230.873 611.748C230.987 611.542 231.26 611.463 231.466 611.577L237.695 615.067C237.832 615.146 237.924 615.295 237.924 615.443V617.758C237.924 617.998 237.73 618.192 237.49 618.192H237.479Z",
    fill: "#001208"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1576",
    d: "M213.203 663.824C212.165 663.243 210.944 663.254 209.928 663.859C208.913 664.452 208.297 665.524 208.297 666.698V666.813L218.235 672.378V666.641L213.203 663.824Z",
    fill: "url(#paint50_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1577",
    d: "M218.038 672.048L208.488 666.699C208.488 664.327 211.044 662.832 213.109 663.996L218.038 666.756V672.048Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1578",
    d: "M218.039 674.613L213.875 672.286V670.621L218.039 672.948V674.613Z",
    fill: "url(#paint51_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1579",
    d: "M214.154 667.406C214.154 668.512 213.458 669.014 212.602 668.512C211.747 668.01 211.051 666.71 211.051 665.604C211.051 664.498 211.747 663.996 212.602 664.498C213.458 665 214.154 666.3 214.154 667.406Z",
    fill: "#FFFFFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1580",
    d: "M216.577 668.923C216.577 669.55 216.178 669.835 215.699 669.55C215.22 669.265 214.82 668.524 214.82 667.896C214.82 667.269 215.22 666.984 215.699 667.269C216.189 667.554 216.577 668.295 216.577 668.923Z",
    fill: "#FFFFFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1581",
    d: "M176.953 642.691C175.915 642.11 172.047 639.852 172.047 639.852V645.68L181.985 651.245V650.675C181.985 647.482 180.262 644.539 177.466 642.977L176.953 642.691Z",
    fill: "url(#paint52_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1582",
    d: "M181.788 650.915L172.238 645.565V640.273L177.167 643.034C180.02 644.63 181.788 647.641 181.788 650.915Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1583",
    d: "M176.473 650.743L172.32 648.416V646.763L176.473 649.089V650.743Z",
    fill: "url(#paint53_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1584",
    d: "M176.381 645.314C176.381 646.421 175.685 646.922 174.829 646.421C173.973 645.919 173.277 644.618 173.277 643.512C173.277 642.406 173.973 641.904 174.829 642.406C175.685 642.908 176.381 644.208 176.381 645.314Z",
    fill: "#FFFFFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1585",
    d: "M178.995 647.128C178.995 647.755 178.596 648.04 178.117 647.755C177.626 647.47 177.238 646.729 177.238 646.101C177.238 645.474 177.638 645.189 178.117 645.474C178.596 645.759 178.995 646.501 178.995 647.128Z",
    fill: "#FFFFFD"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1586",
    d: "M246.426 629.712L251.172 627.123V625.686L246.426 628.263V629.712Z",
    fill: "black"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group 482234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1587",
    d: "M273.298 525.069L276.397 523.294L289.101 530.788C290.361 531.536 291.134 531.501 292.196 530.898L292.534 530.706L295.19 532.272L294.69 532.564C291.897 534.17 288.74 534.189 286.108 532.632L273.305 525.077L273.298 525.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1588",
    d: "M297.626 526.93L299.614 525.794C301.297 524.828 302.281 523.527 302.39 522.131C302.898 522.517 303.28 522.928 303.537 523.356C303.083 524.515 302.081 525.573 300.64 526.397L298.66 527.533C298.21 527.789 297.873 528.105 297.674 528.46C297.51 528.739 297.447 529.04 297.477 529.337C297.006 529.397 296.536 529.433 296.068 529.446C296.006 529.014 296.092 528.59 296.326 528.182C296.586 527.706 297.038 527.279 297.642 526.931L297.626 526.93Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1589",
    d: "M303.281 523.895C303.385 523.713 303.464 523.539 303.537 523.363C303.858 523.88 303.993 524.41 303.955 524.945C303.871 526.031 303.039 527.123 301.446 528.031C301.301 528.109 301.164 528.187 301.02 528.257C299.921 528.819 298.709 529.172 297.477 529.338C297.473 529.267 297.469 529.189 297.473 529.119C297.478 529.042 297.482 528.972 297.501 528.903C297.511 528.856 297.521 528.826 297.531 528.787C297.541 528.741 297.558 528.711 297.568 528.68C297.586 528.635 297.596 528.604 297.613 528.574C297.613 528.574 297.614 528.558 297.622 528.551C297.639 528.521 297.656 528.49 297.674 528.452C297.873 528.097 298.21 527.781 298.661 527.526L300.641 526.389C300.689 526.361 300.738 526.332 300.786 526.304C300.802 526.297 300.818 526.282 300.834 526.275C300.867 526.254 300.891 526.239 300.923 526.218C300.94 526.203 300.963 526.197 300.98 526.182C301.004 526.168 301.036 526.146 301.06 526.132C301.077 526.117 301.101 526.103 301.117 526.096C301.141 526.082 301.166 526.06 301.19 526.046C301.214 526.031 301.23 526.017 301.247 526.002C301.271 525.988 301.295 525.974 301.312 525.951C301.336 525.937 301.353 525.922 301.377 525.908C301.401 525.894 301.417 525.879 301.441 525.865C301.466 525.851 301.482 525.836 301.498 525.821C301.523 525.807 301.539 525.792 301.564 525.77C301.58 525.756 301.604 525.742 301.621 525.727C301.645 525.713 301.661 525.698 301.686 525.676C301.702 525.661 301.726 525.647 301.743 525.632C301.759 525.618 301.783 525.603 301.8 525.581C301.841 525.552 301.874 525.515 301.915 525.486C301.931 525.471 301.947 525.457 301.964 525.442C301.988 525.42 302.005 525.405 302.029 525.383C302.046 525.369 302.062 525.354 302.078 525.347C302.103 525.325 302.119 525.31 302.144 525.288C302.16 525.274 302.177 525.259 302.185 525.252C302.202 525.229 302.226 525.215 302.243 525.193C302.259 525.178 302.268 525.163 302.284 525.148C302.301 525.126 302.325 525.112 302.342 525.089C302.358 525.074 302.367 525.059 302.383 525.052C302.4 525.03 302.424 525.008 302.441 524.993C302.449 524.978 302.465 524.971 302.474 524.956C302.491 524.934 302.515 524.912 302.532 524.889C302.54 524.882 302.549 524.867 302.557 524.86C302.582 524.838 302.599 524.815 302.624 524.785C302.624 524.785 302.632 524.77 302.64 524.763C302.748 524.644 302.841 524.517 302.934 524.39C302.934 524.39 302.934 524.382 302.943 524.375C302.96 524.344 302.984 524.322 303.002 524.292C303.002 524.284 303.01 524.277 303.019 524.27C303.036 524.239 303.053 524.217 303.07 524.187C303.07 524.179 303.079 524.172 303.087 524.164C303.104 524.134 303.121 524.112 303.138 524.082C303.139 524.074 303.147 524.066 303.155 524.059C303.172 524.029 303.189 524.006 303.206 523.976C303.206 523.976 303.207 523.961 303.215 523.953C303.233 523.923 303.25 523.893 303.267 523.863L303.281 523.895Z",
    fill: "url(#paint54_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1590",
    d: "M299.401 522.628C299.64 521.971 299.593 521.282 299.279 520.626C299.846 520.782 300.396 520.992 300.927 521.248C301.061 521.925 300.953 522.605 300.613 523.248C300.221 523.99 299.53 524.653 298.596 525.193L296.608 526.329C295.883 526.748 295.325 527.263 294.989 527.829C294.697 528.326 294.574 528.857 294.63 529.39C294.149 529.34 293.671 529.259 293.202 529.147C293.188 528.546 293.37 527.949 293.72 527.392C294.137 526.76 294.761 526.195 295.582 525.726L297.57 524.59C298.495 524.058 299.133 523.384 299.408 522.636L299.401 522.628Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1591",
    d: "M288.065 524.708C288.149 523.622 288.973 522.53 290.582 521.615C290.711 521.536 290.855 521.466 290.992 521.396C291.585 521.094 292.215 520.848 292.856 520.666L293.422 521.001C293.422 521.001 293.459 521.027 293.474 521.035C293.482 521.036 293.497 521.052 293.504 521.053C293.504 521.053 293.52 521.054 293.52 521.061C293.535 521.07 293.55 521.079 293.564 521.095C293.564 521.095 293.572 521.095 293.58 521.104C293.587 521.104 293.594 521.12 293.602 521.12C293.602 521.12 293.609 521.129 293.617 521.137C293.617 521.137 293.631 521.153 293.639 521.154C293.639 521.154 293.646 521.162 293.654 521.17C293.654 521.17 293.668 521.187 293.676 521.187C293.676 521.187 293.683 521.195 293.691 521.203L293.706 521.22C293.706 521.22 293.713 521.228 293.72 521.236C293.72 521.236 293.727 521.252 293.735 521.253C293.735 521.253 293.742 521.261 293.75 521.269C293.75 521.269 293.756 521.285 293.764 521.285C293.764 521.285 293.772 521.294 293.779 521.302C293.779 521.302 293.786 521.318 293.794 521.318C293.794 521.318 293.793 521.326 293.8 521.334C293.8 521.334 293.8 521.35 293.807 521.35C293.807 521.35 293.806 521.366 293.814 521.366C293.814 521.366 293.813 521.382 293.821 521.39C293.821 521.39 293.82 521.398 293.828 521.406C293.828 521.406 293.827 521.421 293.834 521.429C293.834 521.429 293.834 521.437 293.833 521.445C293.833 521.445 293.832 521.461 293.832 521.468C293.832 521.468 293.831 521.476 293.831 521.484C293.831 521.492 293.83 521.499 293.83 521.507C293.83 521.507 293.829 521.515 293.829 521.523C293.828 521.538 293.828 521.546 293.827 521.562C293.838 521.78 293.694 521.99 293.428 522.139L291.448 523.276C291.4 523.304 291.36 523.325 291.311 523.354C291.295 523.361 291.279 523.375 291.263 523.382C291.231 523.396 291.207 523.418 291.175 523.432C291.158 523.447 291.142 523.454 291.118 523.468C291.094 523.482 291.07 523.496 291.037 523.518C291.021 523.533 290.997 523.539 290.981 523.554C290.957 523.568 290.932 523.582 290.908 523.604C290.891 523.619 290.876 523.626 290.851 523.64C290.827 523.654 290.803 523.668 290.778 523.69C290.762 523.705 290.738 523.712 290.722 523.726C290.698 523.741 290.674 523.755 290.649 523.777C290.633 523.791 290.617 523.798 290.592 523.813C290.568 523.827 290.544 523.841 290.519 523.863C290.503 523.878 290.487 523.885 290.471 523.899C290.447 523.914 290.422 523.936 290.398 523.95C290.381 523.964 290.365 523.971 290.349 523.986C290.324 524.008 290.3 524.022 290.276 524.044C290.26 524.051 290.243 524.066 290.235 524.073C290.194 524.102 290.162 524.131 290.121 524.16C290.105 524.167 290.096 524.182 290.081 524.189C290.056 524.211 290.032 524.225 290.007 524.247C289.991 524.262 289.974 524.277 289.958 524.292C289.942 524.306 289.917 524.32 289.901 524.335C289.885 524.35 289.868 524.364 289.844 524.379C289.828 524.393 289.811 524.408 289.787 524.422C289.771 524.437 289.754 524.452 289.738 524.466C289.721 524.481 289.705 524.496 289.689 524.51C289.672 524.525 289.656 524.54 289.639 524.554C289.623 524.569 289.607 524.584 289.59 524.598C289.574 524.613 289.557 524.628 289.541 524.65C289.524 524.665 289.508 524.679 289.491 524.694C289.475 524.709 289.459 524.723 289.442 524.738C289.426 524.753 289.409 524.767 289.393 524.782C289.377 524.797 289.36 524.811 289.344 524.826C289.327 524.841 289.311 524.855 289.295 524.87C289.278 524.885 289.262 524.899 289.245 524.922C289.229 524.937 289.22 524.952 289.204 524.966C289.17 525.003 289.137 525.041 289.104 525.07C289.088 525.085 289.079 525.1 289.063 525.107C289.047 525.121 289.03 525.144 289.014 525.158C288.997 525.173 288.989 525.188 288.972 525.203C288.956 525.218 288.939 525.24 288.93 525.255C288.914 525.27 288.905 525.285 288.889 525.299C288.872 525.314 288.863 525.337 288.847 525.352C288.831 525.366 288.822 525.381 288.805 525.404C288.789 525.419 288.78 525.441 288.763 525.456C288.747 525.471 288.738 525.486 288.722 525.501C288.705 525.515 288.696 525.538 288.68 525.553C288.671 525.568 288.655 525.583 288.646 525.598C288.63 525.612 288.621 525.635 288.604 525.65C288.596 525.665 288.579 525.68 288.57 525.703C288.554 525.717 288.545 525.74 288.528 525.755C288.52 525.77 288.503 525.792 288.494 525.807C288.486 525.822 288.469 525.845 288.46 525.86C288.452 525.875 288.435 525.898 288.426 525.913C288.418 525.928 288.401 525.95 288.392 525.965C288.375 525.996 288.358 526.018 288.341 526.048C288.341 526.048 288.34 526.056 288.332 526.063C288.093 525.606 287.986 525.14 288.02 524.667L288.065 524.708Z",
    fill: "url(#paint55_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1592",
    d: "M294.518 520.5C294.474 520.467 294.443 520.449 294.413 520.432L294.277 520.354C294.812 520.267 295.352 520.227 295.89 520.21C295.995 520.294 296.083 520.385 296.164 520.467C296.194 520.5 296.216 520.525 296.245 520.557C296.326 520.648 296.391 520.745 296.448 520.834C296.469 520.874 296.491 520.898 296.505 520.93C296.54 520.995 296.568 521.058 296.595 521.122C296.609 521.162 296.623 521.194 296.629 521.218C296.643 521.257 296.649 521.289 296.662 521.321C296.668 521.352 296.674 521.384 296.68 521.415C296.686 521.455 296.692 521.486 296.699 521.51C296.696 521.557 296.702 521.58 296.708 521.612C296.706 521.658 296.704 521.689 296.702 521.721C296.683 522.351 296.253 522.934 295.504 523.368L293.532 524.505C293.476 524.533 293.427 524.569 293.371 524.597C293.355 524.604 293.339 524.619 293.323 524.626C293.282 524.647 293.25 524.668 293.21 524.69C293.194 524.704 293.178 524.711 293.161 524.726C293.129 524.747 293.096 524.769 293.064 524.791C293.048 524.805 293.024 524.812 293.008 524.826C292.975 524.848 292.943 524.87 292.918 524.892C292.902 524.906 292.878 524.92 292.862 524.927C292.829 524.949 292.805 524.971 292.772 524.993C292.756 525.007 292.732 525.021 292.715 525.036C292.691 525.058 292.658 525.08 292.634 525.102C292.617 525.116 292.593 525.131 292.577 525.145C292.552 525.167 292.52 525.189 292.495 525.211C292.479 525.226 292.462 525.24 292.438 525.254C292.414 525.276 292.381 525.298 292.357 525.32C292.34 525.335 292.324 525.349 292.307 525.364C292.283 525.386 292.258 525.408 292.226 525.43C292.21 525.444 292.193 525.459 292.177 525.474C292.152 525.496 292.127 525.518 292.103 525.54C292.086 525.554 292.07 525.569 292.054 525.584C292.029 525.606 292.004 525.628 291.98 525.65C291.963 525.664 291.947 525.679 291.931 525.694C291.906 525.716 291.881 525.738 291.856 525.767C291.84 525.782 291.831 525.797 291.815 525.804C291.79 525.834 291.766 525.856 291.741 525.886C291.732 525.901 291.716 525.908 291.708 525.923C291.675 525.952 291.65 525.982 291.616 526.019C291.616 526.019 291.6 526.034 291.6 526.041C291.533 526.116 291.459 526.197 291.399 526.28C291.399 526.287 291.383 526.294 291.383 526.302C291.358 526.332 291.332 526.362 291.307 526.391C291.299 526.407 291.291 526.414 291.282 526.429C291.265 526.459 291.24 526.481 291.223 526.511C291.214 526.526 291.198 526.541 291.189 526.556C291.172 526.579 291.155 526.609 291.138 526.631C291.13 526.646 291.113 526.669 291.104 526.684C291.087 526.706 291.07 526.729 291.054 526.751C291.045 526.766 291.028 526.789 291.02 526.804C291.003 526.826 290.994 526.849 290.977 526.872C290.968 526.887 290.951 526.909 290.943 526.924C290.926 526.947 290.917 526.97 290.9 526.992C290.891 527.007 290.882 527.03 290.866 527.045C290.857 527.068 290.84 527.09 290.831 527.113C290.822 527.128 290.813 527.151 290.805 527.166C290.796 527.189 290.779 527.211 290.77 527.234C290.761 527.249 290.752 527.272 290.743 527.287C290.734 527.31 290.725 527.333 290.708 527.355C290.707 527.379 290.691 527.393 290.682 527.416C290.672 527.439 290.663 527.462 290.654 527.485C290.653 527.508 290.637 527.523 290.628 527.546C290.619 527.569 290.609 527.591 290.6 527.614C290.599 527.638 290.583 527.652 290.581 527.676C290.58 527.699 290.563 527.729 290.554 527.752C290.553 527.768 290.544 527.79 290.535 527.806C290.533 527.837 290.517 527.859 290.507 527.89C290.506 527.905 290.498 527.92 290.489 527.943C290.479 527.982 290.469 528.02 290.459 528.051C290.435 528.057 290.413 528.048 290.398 528.039C290.284 527.979 290.179 527.91 290.066 527.834C289.765 527.638 289.504 527.436 289.274 527.229C289.409 526.909 289.573 526.607 289.777 526.314C289.802 526.276 289.828 526.239 289.853 526.209C289.886 526.164 289.912 526.127 289.929 526.096C289.929 526.096 289.938 526.081 289.946 526.074C289.971 526.044 289.988 526.014 290.013 525.984C290.014 525.977 290.022 525.969 290.03 525.962C290.055 525.932 290.072 525.902 290.097 525.872C290.098 525.864 290.114 525.857 290.114 525.85C290.139 525.82 290.164 525.79 290.189 525.768C290.189 525.76 290.205 525.753 290.206 525.746C290.231 525.716 290.256 525.686 290.28 525.664C290.281 525.656 290.297 525.649 290.305 525.642C290.33 525.612 290.355 525.583 290.38 525.561C290.38 525.561 290.388 525.545 290.396 525.546C290.421 525.516 290.454 525.487 290.479 525.457C290.611 525.324 290.743 525.199 290.882 525.074C290.89 525.067 290.907 525.052 290.915 525.045C290.939 525.023 290.964 525.001 290.989 524.979C291.005 524.964 291.021 524.957 291.03 524.942C291.054 524.92 291.078 524.906 291.103 524.884C291.119 524.869 291.136 524.855 291.152 524.84C291.177 524.818 291.201 524.804 291.218 524.781C291.234 524.767 291.258 524.752 291.275 524.738C291.299 524.723 291.324 524.701 291.34 524.687C291.364 524.673 291.381 524.658 291.405 524.644C291.429 524.629 291.454 524.607 291.47 524.593C291.494 524.578 291.51 524.564 291.535 524.542C291.559 524.528 291.584 524.506 291.6 524.491C291.624 524.477 291.649 524.455 291.673 524.44C291.697 524.426 291.714 524.412 291.738 524.397C291.762 524.383 291.787 524.361 291.811 524.347C291.835 524.333 291.851 524.318 291.876 524.304C291.9 524.289 291.932 524.268 291.956 524.254C291.98 524.239 291.997 524.225 292.021 524.21C292.053 524.189 292.078 524.175 292.11 524.153C292.134 524.139 292.151 524.124 292.174 524.118C292.207 524.096 292.239 524.082 292.271 524.061C292.287 524.046 292.303 524.039 292.327 524.025C292.376 523.996 292.432 523.968 292.48 523.94L294.453 522.803C294.976 522.505 295.264 522.085 295.257 521.648C295.258 521.625 295.26 521.593 295.254 521.57C295.254 521.562 295.255 521.554 295.255 521.539C295.256 521.523 295.257 521.508 295.25 521.492C295.251 521.484 295.252 521.468 295.244 521.46C295.245 521.445 295.238 521.429 295.231 521.413C295.232 521.405 295.225 521.389 295.218 521.381C295.218 521.365 295.211 521.349 295.204 521.341C295.205 521.333 295.198 521.317 295.19 521.309C295.191 521.294 295.177 521.277 295.169 521.269C295.17 521.261 295.155 521.245 295.155 521.237C295.156 521.221 295.141 521.213 295.134 521.197C295.135 521.189 295.12 521.173 295.113 521.164C295.106 521.149 295.098 521.14 295.092 521.124C295.092 521.117 295.077 521.1 295.07 521.092C295.063 521.076 295.048 521.067 295.041 521.051C295.034 521.043 295.027 521.027 295.019 521.019C295.013 521.003 294.997 520.994 294.991 520.978C294.983 520.97 294.976 520.954 294.961 520.946C294.947 520.929 294.939 520.921 294.925 520.905C294.917 520.896 294.903 520.88 294.895 520.872C294.881 520.855 294.865 520.847 294.859 520.831C294.851 520.823 294.836 520.814 294.829 520.798C294.815 520.782 294.799 520.773 294.785 520.757C294.777 520.748 294.762 520.74 294.755 520.732C294.74 520.715 294.718 520.698 294.703 520.69C294.695 520.689 294.688 520.673 294.681 520.665C294.651 520.64 294.629 520.623 294.598 520.606C294.591 520.606 294.576 520.589 294.569 520.581C294.553 520.572 294.531 520.555 294.516 520.547L294.518 520.5Z",
    fill: "url(#paint56_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1593",
    d: "M293.416 520.993L292.85 520.658C293.317 520.528 293.791 520.422 294.27 520.347L294.406 520.425C294.406 520.425 294.482 520.468 294.511 520.493C294.985 520.808 295.259 521.205 295.275 521.611C295.29 522.048 295.001 522.468 294.47 522.766L292.498 523.903C290.913 524.804 289.805 525.95 289.275 527.214C288.874 526.857 288.575 526.482 288.371 526.096C289.046 525.035 290.096 524.089 291.472 523.293L293.453 522.156C293.718 522.007 293.862 521.797 293.851 521.578C293.839 521.375 293.71 521.173 293.469 521.019C293.454 521.011 293.432 520.994 293.416 520.985V520.993Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1594",
    d: "M287.283 524.664C287.381 523.454 288.297 522.266 290.011 521.286C290.156 521.201 290.309 521.116 290.453 521.046C292.201 520.154 294.283 519.716 296.345 519.761C298.416 519.798 300.467 520.318 302.149 521.315C302.27 521.384 302.39 521.461 302.511 521.538C304.082 522.568 304.824 523.794 304.726 524.996C304.635 526.207 303.712 527.387 302.006 528.367C301.861 528.452 301.709 528.53 301.548 528.614C299.792 529.506 297.726 529.944 295.663 529.907C293.6 529.87 291.557 529.336 289.875 528.346C289.746 528.277 289.634 528.2 289.513 528.123C287.934 527.093 287.2 525.875 287.29 524.672L287.283 524.664ZM292.858 520.666C292.209 520.855 291.588 521.094 290.994 521.396C290.858 521.466 290.714 521.536 290.585 521.614C288.983 522.53 288.151 523.622 288.067 524.708C287.991 525.794 288.647 526.883 290.076 527.82C290.189 527.888 290.294 527.964 290.407 528.025C291.961 528.938 293.782 529.405 295.643 529.439C297.495 529.472 299.379 529.086 301.015 528.249C301.16 528.172 301.304 528.102 301.441 528.024C303.034 527.115 303.866 526.024 303.95 524.938C303.988 524.402 303.854 523.873 303.532 523.356C303.275 522.936 302.892 522.526 302.384 522.131C302.242 522.022 302.1 521.92 301.942 521.818C301.829 521.75 301.724 521.681 301.611 521.613C301.384 521.483 301.157 521.361 300.922 521.247C300.398 520.992 299.849 520.79 299.273 520.625C298.721 520.47 298.151 520.36 297.57 520.289C297.175 520.244 296.772 520.213 296.367 520.206C296.204 520.197 296.048 520.204 295.884 520.211C295.345 520.22 294.805 520.268 294.27 520.355C293.791 520.429 293.318 520.535 292.851 520.665",
    fill: "url(#paint57_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1595",
    d: "M300.968 521.601C300.959 521.483 300.941 521.373 300.925 521.255C301.16 521.362 301.387 521.484 301.613 521.621C301.726 521.69 301.832 521.75 301.945 521.826C302.103 521.929 302.252 522.038 302.387 522.139C302.357 522.535 302.258 522.919 302.09 523.284C302.072 523.322 302.054 523.36 302.036 523.398C302.011 523.443 301.993 523.481 301.975 523.519C301.949 523.572 301.932 523.602 301.906 523.64C301.906 523.64 301.905 523.655 301.897 523.663C301.88 523.693 301.854 523.73 301.837 523.761C301.837 523.768 301.828 523.776 301.82 523.783C301.803 523.813 301.777 523.851 301.76 523.881C301.76 523.889 301.752 523.896 301.743 523.904C301.718 523.933 301.701 523.971 301.676 524.001C301.676 524.001 301.667 524.016 301.659 524.023C301.634 524.053 301.608 524.091 301.591 524.121C301.465 524.285 301.348 524.427 301.215 524.568C301.174 524.604 301.149 524.634 301.125 524.656C301.108 524.671 301.1 524.686 301.084 524.693C301.059 524.715 301.035 524.737 301.018 524.759C301.001 524.774 300.985 524.789 300.969 524.803C300.944 524.825 300.927 524.848 300.903 524.862C300.887 524.877 300.862 524.899 300.846 524.913C300.821 524.935 300.805 524.95 300.78 524.972C300.764 524.987 300.739 525.009 300.723 525.023C300.698 525.045 300.682 525.06 300.657 525.082C300.633 525.096 300.616 525.119 300.592 525.133C300.568 525.147 300.551 525.17 300.527 525.184C300.502 525.206 300.478 525.22 300.453 525.242C300.429 525.256 300.412 525.279 300.388 525.293C300.364 525.315 300.339 525.329 300.315 525.351C300.291 525.365 300.274 525.38 300.25 525.402C300.225 525.424 300.193 525.438 300.168 525.46C300.144 525.474 300.128 525.489 300.104 525.503C300.071 525.525 300.039 525.546 300.015 525.56C299.991 525.575 299.974 525.589 299.95 525.604C299.918 525.625 299.878 525.646 299.845 525.668C299.829 525.675 299.813 525.689 299.797 525.696C299.74 525.732 299.692 525.761 299.636 525.789L297.648 526.925C297.044 527.273 296.592 527.7 296.332 528.176C296.314 528.206 296.305 528.229 296.288 528.259C296.288 528.267 296.279 528.282 296.271 528.29C296.262 528.305 296.253 528.328 296.244 528.343C296.244 528.358 296.235 528.366 296.227 528.381C296.226 528.396 296.209 528.411 296.209 528.426C296.208 528.442 296.199 528.449 296.191 528.464C296.19 528.48 296.181 528.495 296.173 528.51C296.172 528.526 296.163 528.541 296.155 528.548C296.154 528.564 296.153 528.579 296.145 528.586C296.144 528.602 296.136 528.617 296.135 528.633C296.134 528.64 296.134 528.648 296.133 528.656C296.124 528.694 296.114 528.733 296.104 528.771C296.103 528.779 296.103 528.787 296.102 528.794C296.101 528.818 296.1 528.833 296.099 528.857C296.098 528.864 296.098 528.872 296.098 528.88C296.096 528.903 296.095 528.919 296.094 528.942C296.094 528.942 296.093 528.958 296.093 528.965C296.092 528.989 296.09 529.012 296.089 529.028C296.081 529.175 296.082 529.3 296.106 529.434C295.965 529.434 295.825 529.434 295.685 529.434C295.342 529.43 295.009 529.404 294.675 529.377C294.677 529.338 294.671 529.307 294.666 529.268C294.667 529.252 294.667 529.244 294.668 529.229C294.669 529.206 294.67 529.182 294.672 529.159C294.673 529.143 294.673 529.128 294.674 529.12C294.675 529.097 294.676 529.074 294.678 529.05C294.679 529.035 294.679 529.019 294.68 529.004C294.682 528.98 294.683 528.965 294.684 528.941C294.685 528.926 294.686 528.91 294.686 528.895C294.688 528.872 294.689 528.856 294.69 528.833C294.691 528.817 294.692 528.802 294.692 528.786C294.694 528.763 294.695 528.739 294.696 528.716C294.697 528.701 294.698 528.693 294.699 528.677C294.7 528.646 294.71 528.608 294.72 528.577C294.722 528.538 294.74 528.5 294.749 528.462C294.75 528.454 294.751 528.439 294.759 528.431C294.76 528.408 294.769 528.385 294.778 528.362C294.779 528.347 294.78 528.339 294.788 528.324C294.79 528.301 294.806 528.278 294.807 528.263C294.808 528.247 294.817 528.232 294.825 528.217C294.827 528.194 294.844 528.171 294.852 528.156C294.853 528.141 294.862 528.125 294.87 528.118C294.879 528.095 294.888 528.072 294.897 528.057C294.898 528.042 294.906 528.034 294.914 528.019C294.923 527.996 294.94 527.974 294.949 527.951C294.95 527.943 294.958 527.928 294.967 527.921C294.984 527.891 295.002 527.853 295.027 527.823C295.362 527.257 295.92 526.743 296.645 526.323L298.633 525.187C299.567 524.647 300.266 523.985 300.65 523.243C300.676 523.197 300.694 523.152 300.72 523.114C300.721 523.099 300.729 523.083 300.738 523.068C300.755 523.038 300.765 523.007 300.774 522.977C300.775 522.961 300.792 522.939 300.793 522.923C300.802 522.893 300.811 522.87 300.821 522.839C300.822 522.824 300.831 522.801 300.839 522.786C300.841 522.762 300.858 522.732 300.867 522.709C300.868 522.686 300.877 522.671 300.886 522.648C300.887 522.625 300.905 522.595 300.906 522.571C300.907 522.548 300.916 522.533 300.925 522.51C300.926 522.487 300.936 522.456 300.945 522.433C300.946 522.41 300.947 522.394 300.956 522.371C300.958 522.333 300.968 522.286 300.978 522.248C300.98 522.225 300.981 522.201 300.983 522.17C300.984 522.147 300.985 522.131 300.986 522.108C300.988 522.085 300.989 522.054 300.991 522.03C300.991 522.015 300.993 521.992 300.994 521.976C300.995 521.953 300.997 521.922 300.998 521.898C300.999 521.883 301 521.867 301.001 521.844C301.003 521.813 301.004 521.79 301.006 521.759C301.007 521.743 301.007 521.728 301.008 521.712C301.01 521.681 301.012 521.65 301.005 521.626C301.006 521.611 301.007 521.603 301.007 521.587L300.968 521.601Z",
    fill: "url(#paint58_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1596",
    d: "M297.655 520.402C297.626 520.361 297.597 520.329 297.575 520.296C298.156 520.368 298.726 520.477 299.278 520.633C299.3 520.673 299.313 520.712 299.334 520.745C299.355 520.793 299.369 520.832 299.382 520.864C299.403 520.92 299.416 520.96 299.43 520.992C299.456 521.087 299.483 521.158 299.494 521.237C299.507 521.284 299.513 521.324 299.518 521.363C299.531 521.418 299.529 521.457 299.535 521.488C299.545 521.583 299.548 521.661 299.552 521.739C299.549 521.793 299.547 521.824 299.545 521.863C299.542 521.917 299.54 521.956 299.538 521.995C299.532 522.088 299.52 522.166 299.5 522.242C299.497 522.297 299.48 522.327 299.47 522.365C299.459 522.419 299.45 522.458 299.432 522.496C299.413 522.549 299.403 522.588 299.386 522.626C299.11 523.374 298.473 524.047 297.547 524.58L295.559 525.716C294.746 526.185 294.115 526.75 293.698 527.381C293.672 527.419 293.654 527.457 293.629 527.495C293.628 527.51 293.612 527.517 293.611 527.532C293.594 527.555 293.585 527.586 293.568 527.608C293.567 527.624 293.551 527.638 293.542 527.653C293.533 527.676 293.516 527.699 293.507 527.721C293.506 527.737 293.49 527.752 293.481 527.767C293.472 527.79 293.463 527.813 293.446 527.835C293.446 527.851 293.429 527.865 293.428 527.881C293.419 527.904 293.41 527.926 293.401 527.949C293.4 527.965 293.384 527.98 293.382 528.003C293.381 528.026 293.364 528.049 293.355 528.071C293.354 528.087 293.345 528.11 293.337 528.125C293.335 528.148 293.319 528.171 293.317 528.194C293.316 528.21 293.308 528.225 293.299 528.248C293.289 528.286 293.279 528.324 293.269 528.363C293.268 528.386 293.267 528.402 293.258 528.424C293.256 528.448 293.256 528.463 293.246 528.486C293.245 528.509 293.244 528.533 293.235 528.548C293.234 528.563 293.233 528.587 293.232 528.602C293.231 528.626 293.23 528.649 293.228 528.672C293.227 528.688 293.227 528.703 293.225 528.727C293.224 528.75 293.223 528.773 293.221 528.796C293.221 528.812 293.22 528.828 293.219 528.843C293.218 528.866 293.216 528.89 293.215 528.913C293.214 528.929 293.213 528.944 293.212 528.96C293.211 528.983 293.21 529.006 293.208 529.029C293.208 529.045 293.207 529.061 293.206 529.068C293.205 529.092 293.203 529.123 293.202 529.146C292.717 529.033 292.25 528.89 291.793 528.709C291.795 528.67 291.797 528.631 291.799 528.6C291.802 528.546 291.811 528.515 291.821 528.477C291.821 528.469 291.822 528.454 291.823 528.446C291.825 528.415 291.834 528.384 291.844 528.354C291.844 528.338 291.845 528.33 291.846 528.315C291.847 528.284 291.857 528.253 291.866 528.222C291.867 528.207 291.868 528.199 291.869 528.183C291.87 528.152 291.888 528.122 291.897 528.099C291.897 528.084 291.898 528.068 291.907 528.061C291.908 528.03 291.925 528.007 291.935 527.977C291.935 527.961 291.944 527.946 291.953 527.931C291.962 527.9 291.971 527.878 291.981 527.847C291.982 527.831 291.99 527.816 291.999 527.801C292.008 527.771 292.018 527.748 292.035 527.717C292.036 527.702 292.044 527.687 292.053 527.672C292.062 527.641 292.079 527.619 292.089 527.588C292.09 527.572 292.106 527.558 292.107 527.542C292.116 527.512 292.133 527.489 292.143 527.459C292.144 527.443 292.16 527.428 292.169 527.413C292.186 527.383 292.195 527.36 292.212 527.33C292.213 527.314 292.229 527.3 292.238 527.285C292.255 527.262 292.264 527.232 292.281 527.209C292.282 527.194 292.299 527.179 292.307 527.164C292.324 527.141 292.341 527.111 292.358 527.089C292.359 527.073 292.375 527.066 292.384 527.051C292.443 526.961 292.51 526.871 292.578 526.781C292.586 526.766 292.595 526.751 292.611 526.737C292.628 526.714 292.645 526.692 292.662 526.669C292.678 526.655 292.687 526.632 292.704 526.617C292.721 526.595 292.737 526.58 292.754 526.557C292.771 526.535 292.787 526.52 292.804 526.498C292.821 526.476 292.837 526.461 292.854 526.438C292.871 526.416 292.887 526.401 292.904 526.379C292.92 526.364 292.937 526.342 292.954 526.327C292.971 526.305 292.987 526.29 293.012 526.268C293.028 526.253 293.045 526.231 293.061 526.216C293.078 526.194 293.102 526.18 293.119 526.157C293.135 526.142 293.152 526.12 293.176 526.106C293.193 526.083 293.217 526.069 293.234 526.047C293.251 526.032 293.275 526.01 293.292 525.995C293.316 525.973 293.333 525.959 293.357 525.937C293.374 525.922 293.398 525.9 293.415 525.885C293.439 525.863 293.456 525.849 293.48 525.827C293.497 525.812 293.521 525.798 293.538 525.775C293.562 525.753 293.586 525.739 293.611 525.717C293.627 525.702 293.652 525.688 293.668 525.673C293.693 525.651 293.717 525.637 293.741 525.615C293.758 525.6 293.782 525.586 293.798 525.572C293.823 525.55 293.855 525.536 293.88 525.514C293.896 525.499 293.92 525.485 293.936 525.47C293.961 525.448 293.993 525.434 294.018 525.412C294.042 525.398 294.058 525.383 294.082 525.369C294.115 525.348 294.139 525.333 294.171 525.312C294.188 525.297 294.211 525.291 294.228 525.276C294.26 525.254 294.3 525.233 294.333 525.212C294.349 525.205 294.365 525.19 294.381 525.183C294.429 525.155 294.486 525.119 294.542 525.091L296.514 523.954C297.376 523.456 297.918 522.809 298.067 522.092C298.069 522.054 298.079 522.023 298.089 521.985C298.091 521.938 298.094 521.899 298.095 521.868C298.098 521.814 298.1 521.783 298.102 521.744C298.105 521.689 298.107 521.658 298.109 521.619C298.111 521.581 298.105 521.549 298.1 521.51C298.095 521.463 298.089 521.424 298.083 521.392C298.078 521.337 298.064 521.305 298.058 521.274C298.045 521.226 298.04 521.187 298.026 521.155C298.013 521.115 298.007 521.084 297.993 521.044C297.98 520.997 297.966 520.965 297.953 520.925C297.932 520.877 297.919 520.837 297.905 520.806C297.884 520.758 297.871 520.726 297.849 520.693C297.828 520.653 297.806 520.621 297.785 520.588C297.756 520.54 297.735 520.508 297.713 520.475C297.685 520.427 297.655 520.394 297.634 520.362L297.655 520.402Z",
    fill: "url(#paint59_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1597",
    d: "M306.572 512.633L309.671 510.857L319.569 516.699C319.772 516.82 319.968 516.94 320.149 517.059C323.404 519.188 323.542 521.331 319.494 523.645C316.29 525.477 313.273 525.372 310.26 524.479L313.238 522.775C314.488 523.141 315.602 522.868 316.938 522.101C318.862 521 319.246 520.25 317.307 518.981C317.164 518.887 317.013 518.793 316.847 518.698L315.919 518.156C316.306 519.034 316.096 519.864 314.254 520.915C311.517 522.484 306.642 522.579 303.443 520.695C303.33 520.626 303.217 520.557 303.104 520.489C300.156 518.564 300.256 515.936 303.073 514.324C304.835 513.315 306.653 513.276 308.043 513.509L306.564 512.64L306.572 512.633ZM311.076 515.291C309.146 514.685 307.952 514.587 306.093 515.645C304.66 516.469 304.55 517.468 306.331 518.635C306.437 518.703 306.55 518.772 306.671 518.841C309.047 520.243 310.689 520.14 312.242 519.252C314.238 518.109 314.028 517.404 312.857 516.333L311.076 515.291Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1598",
    d: "M270.868 532.757C274.345 530.761 279.292 530.78 282.77 532.828C282.899 532.905 283.019 532.982 283.139 533.059C286.259 535.103 286.061 537.827 282.713 539.744C279.212 541.746 274.311 541.738 270.818 539.674C270.69 539.597 270.57 539.52 270.449 539.443C267.344 537.416 267.504 534.689 270.876 532.758L270.868 532.757ZM279.543 534.666C277.144 533.255 275.303 533.3 273.524 534.323C271.834 535.289 271.646 536.284 273.623 537.578C273.751 537.663 273.886 537.749 274.03 537.835C276.459 539.263 278.262 539.208 280.057 538.178C281.731 537.219 281.95 536.234 279.965 534.931C279.837 534.846 279.694 534.76 279.543 534.674",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1599",
    d: "M246.792 542.35L250.051 540.482L255.769 543.863L261.652 540.505L255.927 537.124L259.186 535.256L274.343 544.196L271.09 546.072L264.565 542.218L258.682 545.576L265.207 549.43L261.955 551.298L246.792 542.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1600",
    d: "M348.411 497.834L351.348 496.151C352.349 496.511 353.132 496.578 354.71 495.676C356.03 494.923 356.431 494.439 355.814 494.039C355.791 494.03 355.776 494.013 355.754 494.004C354.946 493.531 354.498 493.607 352.421 494.38C350.066 495.262 346.692 496.383 344.111 494.86C344.044 494.817 343.983 494.783 343.923 494.74C341.788 493.344 342.943 491.491 345.463 490.042C348.143 488.508 351.087 488.251 353.864 489.317L350.934 491.001C349.928 490.735 349.32 490.747 348.064 491.464C346.776 492.203 346.581 492.636 347.152 493.011C347.174 493.028 347.197 493.037 347.22 493.054C347.831 493.415 348.507 493.305 350.616 492.51C353.099 491.581 356.186 490.576 358.706 492.065C358.781 492.108 358.849 492.151 358.917 492.193C361.307 493.76 359.758 495.692 357.295 497.106C354.325 498.81 351.485 499.011 348.402 497.842L348.411 497.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1601",
    d: "M332.118 498.002L334.243 496.788L332.689 495.868C332.598 495.816 332.515 495.765 332.433 495.714C330.2 494.257 330.304 492.237 332.485 490.987C333.226 490.56 334.057 490.194 334.962 489.886L337.587 491.442C336.866 491.659 336.212 491.934 335.64 492.269C334.747 492.772 334.614 493.334 335.622 493.998C335.674 494.032 335.734 494.074 335.802 494.109L337.342 495.013L340.344 493.294L342.999 494.86L339.997 496.579L348.628 501.672L345.529 503.448L336.898 498.354L334.782 499.569L332.126 498.003L332.118 498.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1602",
    d: "M325.23 501.632C328.473 499.779 331.866 499.719 334.688 501.38L338.211 503.454C338.951 503.884 339.468 503.828 339.999 503.53L340.257 503.381L342.912 504.947L342.446 505.209C340.683 506.217 339.565 506.295 338.223 506.033C338.714 506.879 337.904 508.127 336.174 509.122C333.976 510.379 330.674 510.919 328.146 509.431C328.078 509.396 328.018 509.353 327.958 509.319C325.732 507.863 327.105 505.89 329.342 504.612C330.156 504.119 331.173 503.771 332.314 503.577L331.469 503.078C330.164 502.304 329.233 502.229 327.736 503.089C326.697 503.685 326.324 504.093 326.889 504.724L323.871 506.45C322.123 504.537 322.936 502.946 325.23 501.632ZM334.419 504.816C333.472 504.888 332.746 505.043 331.483 505.759C330.276 506.448 330.212 506.904 331.031 507.441C331.084 507.475 331.136 507.509 331.197 507.543C332.125 508.086 332.919 508.099 334.086 507.432C335.278 506.742 335.755 506.278 335.512 505.47L334.419 504.816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1603",
    d: "M311.989 509.527L315.08 507.752L316.724 508.724C316.079 507.714 316.49 506.63 317.923 505.806C318.382 505.543 318.932 505.325 319.381 505.24L322.406 507.03C321.933 507.12 321.375 507.346 320.779 507.695C319.105 508.654 318.754 509.779 320.761 511.091C320.867 511.159 320.98 511.228 321.1 511.305L326.358 514.411L323.259 516.186L311.981 509.527H311.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1604",
    d: "M295.499 523.375C296.248 522.941 296.678 522.358 296.697 521.728C296.712 521.191 296.43 520.653 295.886 520.202C296.05 520.195 296.206 520.196 296.37 520.198C296.774 520.205 297.17 520.242 297.573 520.28C298.031 520.859 298.214 521.493 298.086 522.117C297.937 522.833 297.395 523.481 296.533 523.978L294.561 525.115C292.911 526.059 291.936 527.33 291.79 528.693C291.333 528.512 290.885 528.3 290.462 528.058C290.803 526.698 291.869 525.456 293.527 524.504L295.5 523.367L295.499 523.375Z",
    fill: "#161616"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1605",
    d: "M327.465 574.597L332.687 572.289C336.759 570.488 340.679 567.494 343.977 563.668C343.312 565.765 342.313 567.791 341.033 569.671C338.444 573.454 334.712 576.658 330.278 578.618C327.002 580.065 324.051 580.535 321.613 580.123C322.279 578.951 323.118 577.866 324.08 576.933C325.121 575.92 326.286 575.125 327.472 574.597H327.465Z",
    fill: "url(#paint60_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1606",
    d: "M340.593 547.749C343.494 549.239 345.295 552.363 345.461 556.877C345.627 561.39 344.13 566.004 341.432 569.953C338.735 573.902 334.858 577.215 330.294 579.233C325.73 581.251 321.701 581.439 318.808 579.964C315.908 578.481 314.129 575.349 313.955 570.814C313.781 566.279 315.271 561.723 317.969 557.766C320.66 553.81 324.544 550.49 329.129 548.458C333.715 546.425 337.693 546.281 340.593 547.763V547.749ZM344.868 558.916C344.904 558.323 344.911 557.723 344.89 557.122C344.723 552.768 343.002 549.788 340.224 548.364C337.44 546.946 333.592 547.091 329.151 549.043C324.688 551.018 320.956 554.229 318.374 558.019C316.414 560.905 315.112 564.138 314.678 567.436C314.541 568.471 314.49 569.505 314.534 570.539C314.534 570.698 314.548 570.85 314.555 571.009C314.628 572.102 314.801 573.107 315.062 574.018C315.322 574.915 315.669 575.718 316.103 576.427C316.523 577.114 317.022 577.714 317.586 578.228C318.071 578.662 318.606 579.023 319.184 579.32C319.271 579.363 319.358 579.407 319.445 579.443C320.11 579.754 320.833 579.978 321.615 580.108C324.052 580.52 327.003 580.058 330.279 578.604C334.72 576.644 338.452 573.44 341.035 569.657C342.315 567.776 343.313 565.751 343.978 563.654C344.47 562.099 344.774 560.507 344.868 558.909",
    fill: "url(#paint61_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1607",
    d: "M345.309 556.746L345.721 556.565L345.735 557.007L345.323 557.187L345.309 556.746Z",
    fill: "url(#paint62_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1608",
    d: "M339.533 561.946C341.573 559.921 343.331 557.541 344.669 554.988C344.792 555.661 344.864 556.37 344.893 557.122C344.915 557.722 344.907 558.315 344.871 558.916C341.624 563.711 337.233 567.523 332.583 569.584L327.361 571.891C325.77 572.593 324.207 573.678 322.804 575.045C321.48 576.325 320.33 577.837 319.441 579.457C319.354 579.413 319.267 579.377 319.18 579.334C318.602 579.037 318.067 578.668 317.582 578.242C318.71 576.289 320.128 574.473 321.748 572.94C323.455 571.32 325.336 570.032 327.252 569.186L332.474 566.879C334.97 565.78 337.378 564.094 339.526 561.953L339.533 561.946Z",
    fill: "url(#paint63_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1609",
    d: "M327.266 569.179C325.35 570.025 323.469 571.312 321.762 572.932C320.142 574.473 318.724 576.281 317.596 578.234C317.032 577.728 316.533 577.127 316.113 576.433C317.473 574.27 319.115 572.289 320.959 570.603C322.898 568.831 325.017 567.421 327.165 566.473L332.387 564.166C334.832 563.081 337.19 561.317 339.207 559.06C341.124 556.919 342.65 554.424 343.641 551.827C344.119 552.746 344.466 553.802 344.675 554.995C343.33 557.548 341.58 559.928 339.54 561.953C337.392 564.094 334.984 565.779 332.524 566.864L327.273 569.186L327.266 569.179Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1610",
    d: "M338.475 556.486C340.139 554.382 341.339 551.951 341.911 549.543C342.59 550.172 343.169 550.932 343.632 551.829C342.641 554.425 341.115 556.92 339.198 559.061C337.18 561.318 334.815 563.083 332.378 564.168L327.156 566.475C325 567.43 322.888 568.833 320.95 570.605C319.106 572.29 317.457 574.272 316.104 576.434C315.67 575.726 315.323 574.923 315.062 574.026C318.281 569.419 322.556 565.759 327.054 563.77L332.276 561.463C334.548 560.45 336.725 558.707 338.475 556.486Z",
    fill: "url(#paint64_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1611",
    d: "M332.275 561.462L327.053 563.77C322.554 565.759 318.28 569.418 315.061 574.026C314.801 573.114 314.627 572.116 314.555 571.017C318.055 566.569 322.409 563.068 326.952 561.057L332.174 558.75C334.155 557.868 336.036 556.248 337.425 554.201C338.734 552.27 339.537 550.114 339.667 548.104C339.855 548.183 340.043 548.27 340.224 548.357C340.839 548.675 341.403 549.065 341.909 549.528C341.338 551.937 340.137 554.36 338.473 556.472C336.716 558.692 334.546 560.443 332.275 561.448V561.462Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1612",
    d: "M314.42 570.698L314.297 567.501L314.847 567.255L314.97 570.459L314.42 570.698Z",
    fill: "url(#paint65_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1613",
    d: "M337.079 548.328L337.05 547.475C337.998 547.569 338.873 547.778 339.669 548.111C339.669 548.162 339.661 548.22 339.654 548.27C339.654 548.35 339.64 548.4 339.64 548.451C339.632 548.545 339.625 548.588 339.618 548.639C339.604 548.74 339.596 548.784 339.596 548.827C339.582 548.936 339.575 548.979 339.567 549.022C339.553 549.131 339.538 549.174 339.531 549.218C339.51 549.326 339.502 549.37 339.495 549.413C339.473 549.521 339.466 549.565 339.452 549.608C339.423 549.724 339.416 549.76 339.408 549.804C339.408 549.825 339.394 549.854 339.394 549.876C339.387 549.919 339.372 549.955 339.365 549.999C339.365 550.021 339.35 550.049 339.343 550.071C339.329 550.115 339.321 550.158 339.307 550.194C339.278 550.31 339.264 550.353 339.249 550.389C339.213 550.505 339.206 550.549 339.191 550.592C339.155 550.7 339.141 550.744 339.126 550.794C339.083 550.917 339.047 551.026 339.003 551.134C338.974 551.221 338.96 551.257 338.945 551.301C338.938 551.33 338.924 551.359 338.916 551.38C338.902 551.416 338.888 551.453 338.873 551.489C338.859 551.518 338.851 551.554 338.837 551.583C338.822 551.619 338.808 551.648 338.793 551.684C338.779 551.713 338.765 551.749 338.75 551.778C338.736 551.814 338.721 551.843 338.707 551.879C338.692 551.916 338.678 551.944 338.663 551.981C338.649 552.01 338.634 552.046 338.62 552.075C338.605 552.111 338.591 552.14 338.577 552.176C338.562 552.205 338.548 552.241 338.533 552.27C338.519 552.306 338.504 552.335 338.482 552.371C338.468 552.4 338.454 552.436 338.439 552.465C338.425 552.501 338.403 552.538 338.388 552.566C338.374 552.595 338.36 552.632 338.338 552.661C338.323 552.697 338.302 552.733 338.287 552.762C338.273 552.791 338.258 552.82 338.237 552.856C338.215 552.892 338.2 552.928 338.179 552.964C338.164 552.993 338.15 553.022 338.128 553.051C338.106 553.087 338.092 553.123 338.07 553.16C338.056 553.188 338.034 553.217 338.02 553.246C337.998 553.283 337.976 553.319 337.955 553.355C337.94 553.384 337.918 553.413 337.904 553.442C337.882 553.478 337.86 553.514 337.839 553.55C337.824 553.579 337.803 553.601 337.788 553.63C337.766 553.666 337.738 553.709 337.716 553.745C337.701 553.767 337.687 553.796 337.672 553.818C337.643 553.861 337.622 553.897 337.593 553.941C337.506 554.071 337.47 554.129 337.427 554.194C336.038 556.233 334.157 557.861 332.176 558.743L326.953 561.051C326.881 561.079 326.809 561.116 326.736 561.145C326.621 561.195 326.57 561.217 326.519 561.246C326.491 561.26 326.462 561.275 326.433 561.282C326.389 561.304 326.346 561.325 326.303 561.34C326.266 561.354 326.23 561.376 326.201 561.39C326.165 561.405 326.129 561.427 326.093 561.441C326.057 561.456 326.02 561.477 325.984 561.492C325.948 561.506 325.912 561.528 325.876 561.542C325.84 561.557 325.803 561.579 325.767 561.593C325.731 561.607 325.695 561.629 325.659 561.644C325.623 561.658 325.586 561.68 325.55 561.701C325.514 561.723 325.478 561.738 325.442 561.759C325.406 561.781 325.369 561.795 325.333 561.817C325.297 561.839 325.261 561.853 325.225 561.875C325.189 561.897 325.153 561.911 325.116 561.933C325.08 561.947 325.051 561.969 325.015 561.984C324.979 562.005 324.936 562.027 324.899 562.049C324.87 562.063 324.834 562.085 324.805 562.099C324.769 562.121 324.733 562.143 324.697 562.164C324.661 562.186 324.632 562.201 324.596 562.222C324.559 562.244 324.523 562.266 324.48 562.287C324.451 562.309 324.415 562.323 324.386 562.345C324.35 562.367 324.306 562.389 324.27 562.418C324.241 562.432 324.212 562.454 324.183 562.468C324.14 562.49 324.104 562.519 324.06 562.54C324.031 562.555 324.002 562.577 323.974 562.591C323.93 562.613 323.887 562.642 323.851 562.663C323.822 562.678 323.793 562.7 323.771 562.714C323.728 562.743 323.684 562.765 323.648 562.794C323.619 562.808 323.59 562.83 323.561 562.844C323.518 562.873 323.475 562.895 323.438 562.924C323.409 562.938 323.38 562.96 323.359 562.974C323.315 563.003 323.272 563.025 323.229 563.054C323.2 563.068 323.178 563.09 323.149 563.105C323.106 563.134 323.062 563.162 323.019 563.191C322.99 563.206 322.968 563.228 322.939 563.242C322.896 563.271 322.852 563.3 322.809 563.329C322.787 563.343 322.758 563.365 322.737 563.379C322.693 563.408 322.65 563.437 322.607 563.466C322.585 563.481 322.563 563.495 322.534 563.51C322.491 563.539 322.44 563.575 322.397 563.604C322.375 563.618 322.353 563.633 322.332 563.647C322.288 563.676 322.238 563.712 322.194 563.741C322.173 563.756 322.151 563.77 322.129 563.784C322.079 563.821 322.035 563.85 321.985 563.886C321.876 563.958 321.833 563.994 321.782 564.03C321.681 564.103 321.63 564.139 321.58 564.175C321.478 564.247 321.428 564.284 321.377 564.327C321.276 564.399 321.225 564.443 321.174 564.479C321.08 564.551 321.03 564.587 320.972 564.631C320.885 564.703 320.827 564.739 320.769 564.783C320.683 564.848 320.625 564.898 320.567 564.942C320.495 565 320.429 565.05 320.372 565.101C318.795 566.367 317.305 567.799 315.916 569.368C315.858 569.433 315.801 569.498 315.743 569.563C315.685 569.636 315.627 569.701 315.569 569.766C315.511 569.838 315.453 569.903 315.396 569.969C315.338 570.041 315.28 570.106 315.229 570.171C315.171 570.243 315.113 570.308 315.063 570.374C314.998 570.446 314.947 570.511 314.896 570.576C314.831 570.656 314.781 570.721 314.73 570.786C314.672 570.858 314.614 570.93 314.564 570.996C314.549 570.844 314.542 570.692 314.535 570.533C314.499 569.498 314.549 568.457 314.679 567.43C315.019 567.054 315.359 566.685 315.707 566.323C315.764 566.258 315.822 566.2 315.88 566.142C315.945 566.077 315.996 566.019 316.054 565.969C316.119 565.904 316.177 565.846 316.227 565.795C316.292 565.73 316.35 565.672 316.401 565.622C316.473 565.549 316.524 565.499 316.582 565.448C316.654 565.376 316.705 565.325 316.762 565.274C316.835 565.209 316.885 565.159 316.943 565.101C317.016 565.036 317.073 564.978 317.124 564.927C317.196 564.862 317.247 564.812 317.305 564.754C317.37 564.689 317.428 564.638 317.486 564.587C317.551 564.529 317.609 564.472 317.667 564.421C317.732 564.363 317.79 564.305 317.847 564.255C317.912 564.197 317.97 564.146 318.035 564.088C318.954 563.271 319.902 562.512 320.863 561.817C320.921 561.774 320.979 561.738 321.037 561.694C321.117 561.636 321.174 561.6 321.225 561.557C321.312 561.499 321.363 561.463 321.413 561.427C321.5 561.362 321.551 561.333 321.601 561.296C321.702 561.224 321.746 561.195 321.796 561.166C321.898 561.094 321.948 561.065 321.992 561.036C322.093 560.964 322.144 560.935 322.187 560.906C322.209 560.891 322.23 560.877 322.252 560.862C322.296 560.834 322.339 560.805 322.382 560.776C322.404 560.761 322.426 560.747 322.447 560.732C322.491 560.703 322.534 560.674 322.578 560.645C322.599 560.631 322.628 560.617 322.65 560.602C322.693 560.573 322.737 560.551 322.773 560.523C322.802 560.508 322.824 560.486 322.852 560.472C322.896 560.45 322.932 560.421 322.975 560.4C323.004 560.385 323.033 560.363 323.055 560.349C323.091 560.327 323.135 560.298 323.171 560.277C323.2 560.262 323.229 560.24 323.25 560.226C323.286 560.204 323.33 560.175 323.366 560.154C323.395 560.139 323.424 560.117 323.453 560.103C323.489 560.081 323.532 560.06 323.569 560.031C323.597 560.016 323.626 559.995 323.655 559.98C323.691 559.958 323.735 559.937 323.771 559.915C323.8 559.901 323.829 559.879 323.858 559.864C323.894 559.843 323.937 559.821 323.974 559.799C324.002 559.785 324.031 559.763 324.06 559.749C324.097 559.727 324.133 559.705 324.169 559.684C324.198 559.662 324.234 559.647 324.263 559.633C324.299 559.611 324.335 559.597 324.371 559.575C324.4 559.561 324.436 559.539 324.465 559.524C324.502 559.503 324.538 559.481 324.574 559.467C324.603 559.452 324.639 559.43 324.668 559.416C324.704 559.394 324.74 559.373 324.776 559.358C324.805 559.344 324.841 559.322 324.87 559.307C324.907 559.286 324.943 559.271 324.979 559.25C325.015 559.235 325.044 559.213 325.08 559.199C325.116 559.177 325.152 559.163 325.189 559.141C325.225 559.127 325.254 559.105 325.29 559.09C325.326 559.076 325.362 559.054 325.391 559.04C325.427 559.025 325.456 559.004 325.492 558.989C325.529 558.975 325.565 558.953 325.594 558.939C325.63 558.924 325.666 558.902 325.695 558.888C325.731 558.873 325.76 558.852 325.796 558.837C325.832 558.816 325.869 558.801 325.912 558.779C325.941 558.765 325.977 558.75 326.006 558.736C326.042 558.714 326.086 558.7 326.122 558.678C326.151 558.664 326.187 558.649 326.216 558.635C326.252 558.62 326.288 558.599 326.324 558.584C326.353 558.57 326.389 558.555 326.418 558.541C326.462 558.519 326.512 558.497 326.556 558.476C326.577 558.468 326.599 558.454 326.621 558.447C326.693 558.418 326.758 558.382 326.831 558.353L332.045 556.045C333.434 555.431 334.736 554.273 335.676 552.827C336.616 551.38 337.115 549.76 337.065 548.321L337.079 548.328Z",
    fill: "url(#paint66_linear_3256_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1614",
    d: "M332.067 556.052L326.852 558.36C322.498 560.284 318.282 563.43 314.68 567.451C314.868 566.012 315.222 564.58 315.728 563.191C319.135 559.936 322.896 557.362 326.751 555.655L331.973 553.347C332.668 553.044 333.319 552.458 333.781 551.742C334.252 551.018 334.505 550.208 334.476 549.485L334.403 547.532C335.336 547.417 336.219 547.402 337.051 547.482L337.08 548.335C337.137 549.767 336.631 551.387 335.691 552.841C334.751 554.288 333.449 555.445 332.06 556.06L332.067 556.052Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1615",
    d: "M318.373 558.027C320.955 554.23 324.687 551.026 329.15 549.052C331.016 548.227 332.774 547.728 334.394 547.525L334.466 549.478C334.495 550.202 334.242 551.004 333.772 551.735C333.302 552.451 332.651 553.037 331.964 553.341L326.741 555.648C326.619 555.706 326.496 555.756 326.373 555.814C326.329 555.836 326.293 555.85 326.25 555.872C326.17 555.908 326.091 555.944 326.004 555.988C325.953 556.009 325.902 556.031 325.859 556.06C325.787 556.096 325.714 556.132 325.642 556.169C325.591 556.197 325.534 556.219 325.483 556.248C325.411 556.284 325.346 556.32 325.273 556.349C325.223 556.378 325.165 556.407 325.114 556.429C325.049 556.465 324.977 556.501 324.912 556.53C324.854 556.559 324.796 556.588 324.745 556.617C324.68 556.653 324.615 556.682 324.55 556.718C324.492 556.747 324.434 556.783 324.376 556.812C324.311 556.848 324.246 556.877 324.188 556.914C324.13 556.942 324.073 556.979 324.015 557.008C323.95 557.044 323.892 557.08 323.827 557.109C323.769 557.145 323.711 557.174 323.646 557.21C323.588 557.246 323.523 557.282 323.465 557.319C323.407 557.355 323.342 557.391 323.284 557.427C323.226 557.463 323.169 557.499 323.103 557.536C323.046 557.572 322.98 557.608 322.923 557.644C322.865 557.68 322.807 557.716 322.749 557.753C322.684 557.789 322.626 557.825 322.561 557.868C322.503 557.904 322.445 557.941 322.387 557.977C322.322 558.013 322.264 558.056 322.199 558.092C322.141 558.129 322.084 558.165 322.026 558.201C321.961 558.244 321.903 558.281 321.838 558.324C321.78 558.36 321.729 558.396 321.671 558.432C321.606 558.476 321.548 558.512 321.483 558.555C321.425 558.592 321.375 558.628 321.317 558.664C321.252 558.707 321.187 558.751 321.129 558.794C321.078 558.83 321.02 558.866 320.97 558.903C320.905 558.946 320.84 558.989 320.774 559.033C320.724 559.069 320.673 559.105 320.615 559.141C320.55 559.185 320.485 559.235 320.42 559.279C320.369 559.315 320.319 559.351 320.268 559.387C320.203 559.438 320.138 559.481 320.066 559.532C320.015 559.568 319.964 559.604 319.921 559.64C319.856 559.691 319.784 559.742 319.718 559.792C319.675 559.828 319.624 559.864 319.581 559.893C319.509 559.944 319.444 560.002 319.371 560.053C319.328 560.081 319.292 560.118 319.248 560.147C319.176 560.204 319.104 560.262 319.024 560.32C318.988 560.349 318.952 560.378 318.916 560.407C318.836 560.472 318.757 560.53 318.684 560.595C318.655 560.617 318.626 560.638 318.597 560.667C318.511 560.732 318.431 560.805 318.344 560.87C318.33 560.884 318.315 560.899 318.294 560.906C317.766 561.34 317.238 561.788 316.724 562.251C316.594 562.367 316.507 562.447 316.42 562.526C316.399 562.548 316.377 562.562 316.355 562.584C316.276 562.656 316.189 562.736 316.109 562.808C316.08 562.837 316.051 562.859 316.023 562.888C315.943 562.96 315.871 563.032 315.791 563.105C315.769 563.126 315.74 563.148 315.719 563.177C316.37 561.383 317.259 559.648 318.366 558.02L318.373 558.027Z",
    fill: "url(#paint67_linear_3256_4486)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1616",
    d: "M332.583 569.584C337.234 567.53 341.624 563.711 344.872 558.916C344.778 560.522 344.467 562.113 343.982 563.661C340.684 567.487 336.757 570.481 332.692 572.282L327.47 574.589C326.284 575.117 325.119 575.913 324.078 576.926C323.116 577.859 322.284 578.944 321.611 580.115C320.83 579.985 320.107 579.761 319.441 579.45C320.338 577.822 321.488 576.318 322.805 575.038C324.208 573.671 325.77 572.593 327.361 571.884L332.583 569.577V569.584Z",
    fill: "#151515"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3256_4486",
    x1: 260.94,
    y1: 650.971,
    x2: 300.194,
    y2: 635.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3256_4486",
    x1: 259.251,
    y1: 649.405,
    x2: 272.1,
    y2: 646.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3256_4486",
    x1: 348.888,
    y1: 611.45,
    x2: 365.358,
    y2: 607.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3256_4486",
    x1: 353.938,
    y1: 602.374,
    x2: 357.889,
    y2: 601.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3256_4486",
    x1: 357.528,
    y1: 594.55,
    x2: 358.767,
    y2: 594.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3256_4486",
    x1: 357.194,
    y1: 602.764,
    x2: 358.684,
    y2: 602.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3256_4486",
    x1: 354.147,
    y1: 594.573,
    x2: 355.932,
    y2: 593.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3256_4486",
    x1: 358.386,
    y1: 597.777,
    x2: 359.33,
    y2: 597.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3256_4486",
    x1: 351.426,
    y1: 605.233,
    x2: 352.921,
    y2: 604.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3256_4486",
    x1: 354.126,
    y1: 605.259,
    x2: 355.993,
    y2: 604.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3256_4486",
    x1: 350.729,
    y1: 602.609,
    x2: 351.66,
    y2: 602.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3256_4486",
    x1: 351.47,
    y1: 598.118,
    x2: 353.002,
    y2: 597.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3256_4486",
    x1: 323.907,
    y1: 625.8,
    x2: 340.377,
    y2: 621.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3256_4486",
    x1: 328.969,
    y1: 616.724,
    x2: 332.92,
    y2: 615.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3256_4486",
    x1: 332.525,
    y1: 609.04,
    x2: 333.764,
    y2: 608.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3256_4486",
    x1: 332.203,
    y1: 617.253,
    x2: 333.693,
    y2: 616.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3256_4486",
    x1: 329.155,
    y1: 609.063,
    x2: 330.94,
    y2: 608.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3256_4486",
    x1: 333.383,
    y1: 612.267,
    x2: 334.328,
    y2: 612.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3256_4486",
    x1: 326.426,
    y1: 619.722,
    x2: 327.921,
    y2: 619.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3256_4486",
    x1: 329.135,
    y1: 619.748,
    x2: 331.002,
    y2: 618.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3256_4486",
    x1: 325.737,
    y1: 617.099,
    x2: 326.668,
    y2: 616.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3256_4486",
    x1: 326.466,
    y1: 612.607,
    x2: 327.998,
    y2: 612.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3256_4486",
    x1: 276.075,
    y1: 646.276,
    x2: 416.839,
    y2: 596.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3256_4486",
    x1: 227.968,
    y1: 579.904,
    x2: 383.582,
    y2: 477.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3256_4486",
    x1: 219.769,
    y1: 641.816,
    x2: 282.623,
    y2: 628.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3256_4486",
    x1: 184.897,
    y1: 614.487,
    x2: 186.669,
    y2: 614.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3256_4486",
    x1: 177.585,
    y1: 592.659,
    x2: 185.721,
    y2: 587.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3256_4486",
    x1: 188.029,
    y1: 614.349,
    x2: 260.963,
    y2: 566.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3256_4486",
    x1: 256.062,
    y1: 674.901,
    x2: 249.659,
    y2: 642.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3256_4486",
    x1: 245.22,
    y1: 670.771,
    x2: 261.69,
    y2: 666.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3256_4486",
    x1: 250.266,
    y1: 661.706,
    x2: 254.217,
    y2: 660.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3256_4486",
    x1: 253.837,
    y1: 654.01,
    x2: 255.076,
    y2: 653.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3256_4486",
    x1: 253.503,
    y1: 662.224,
    x2: 254.992,
    y2: 661.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3256_4486",
    x1: 250.455,
    y1: 654.033,
    x2: 252.241,
    y2: 653.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3256_4486",
    x1: 254.694,
    y1: 657.237,
    x2: 255.639,
    y2: 657.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3256_4486",
    x1: 247.734,
    y1: 664.693,
    x2: 249.23,
    y2: 664.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3256_4486",
    x1: 250.435,
    y1: 664.731,
    x2: 252.302,
    y2: 663.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3256_4486",
    x1: 247.037,
    y1: 662.08,
    x2: 247.969,
    y2: 661.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3256_4486",
    x1: 247.767,
    y1: 657.59,
    x2: 249.299,
    y2: 657.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3256_4486",
    x1: 171.301,
    y1: 639.409,
    x2: 175.995,
    y2: 637.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3256_4486",
    x1: 178.879,
    y1: 649.163,
    x2: 239.878,
    y2: 628.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3256_4486",
    x1: 219.551,
    y1: 679.226,
    x2: 239.652,
    y2: 672.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3256_4486",
    x1: 171.412,
    y1: 651.472,
    x2: 179.105,
    y2: 650.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3256_4486",
    x1: 176.143,
    y1: 681.358,
    x2: 228.297,
    y2: 656.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3256_4486",
    x1: 196.079,
    y1: 588.013,
    x2: 200.234,
    y2: 586.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3256_4486",
    x1: 208.712,
    y1: 594.857,
    x2: 212.867,
    y2: 593.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3256_4486",
    x1: 221.337,
    y1: 601.699,
    x2: 225.492,
    y2: 600.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3256_4486",
    x1: 183.437,
    y1: 659.595,
    x2: 218.473,
    y2: 644.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3256_4486",
    x1: 241.03,
    y1: 642.76,
    x2: 242.802,
    y2: 642.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3256_4486",
    x1: 233.734,
    y1: 620.919,
    x2: 241.858,
    y2: 615.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3256_4486",
    x1: 208.954,
    y1: 673.344,
    x2: 219.738,
    y2: 668.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3256_4486",
    x1: 214.15,
    y1: 675.042,
    x2: 218.745,
    y2: 673.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_3256_4486",
    x1: 172.704,
    y1: 652.47,
    x2: 184.13,
    y2: 648.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_3256_4486",
    x1: 172.595,
    y1: 651.171,
    x2: 177.177,
    y2: 649.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_3256_4486",
    x1: 303.667,
    y1: 522.692,
    x2: 296.556,
    y2: 524.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_3256_4486",
    x1: 293.538,
    y1: 520.097,
    x2: 287.135,
    y2: 522.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_3256_4486",
    x1: 296.363,
    y1: 519.361,
    x2: 288.053,
    y2: 521.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_3256_4486",
    x1: 303.902,
    y1: 519.076,
    x2: 287.683,
    y2: 528.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_3256_4486",
    x1: 301.999,
    y1: 520.404,
    x2: 293.435,
    y2: 522.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_3256_4486",
    x1: 299.194,
    y1: 519.409,
    x2: 290.485,
    y2: 521.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_3256_4486",
    x1: 323.092,
    y1: 582.05,
    x2: 345.738,
    y2: 570.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_3256_4486",
    x1: 316.026,
    y1: 584.603,
    x2: 351.861,
    y2: 572.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_3256_4486",
    x1: 345.337,
    y1: 557.254,
    x2: 345.846,
    y2: 557.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_3256_4486",
    x1: 319.389,
    y1: 582.087,
    x2: 348.958,
    y2: 569.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_3256_4486",
    x1: 316.952,
    y1: 579.326,
    x2: 348.318,
    y2: 566.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_3256_4486",
    x1: 314.341,
    y1: 571.068,
    x2: 315.194,
    y2: 571.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_3256_4486",
    x1: 316.186,
    y1: 573.524,
    x2: 343.746,
    y2: 562.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_3256_4486",
    x1: 316.958,
    y1: 564.86,
    x2: 336.799,
    y2: 555.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroMobTruck);
export default __webpack_public_path__ + "static/media/hero-mob-truck.c80c80453761e590e18e246054cd3454.svg";
export { ForwardRef as ReactComponent };